import { useAssistantContext } from './useAssistantContext';

export function useUiManager() {
    const context = useAssistantContext();

  return context.assistantUiManager!;
}